<template>
  <common-dialog
    :show-dialog.sync="showDialog"
    :show-btn="isEdit"
    title="修改密码"
    @handleConfirm="modifyPwd"
    @handleClose="handleClose"
  >
    <el-form
      label-width="20%"
      :model="adminInfo"
      :rules="adminRules"
      ref="adminInfo"
    >
      <el-form-item label="旧密码" prop="password" v-if="showPwd">
        <el-input
          type="text"
          prefix-icon="el-icon-lock"
          show-password
          clearable
          autocomplete="off"
          v-model.trim="adminInfo.password"
          placeholder="输入旧密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword" v-if="showPwd">
        <el-input
          type="text"
          prefix-icon="el-icon-lock"
          show-password
          clearable
          autocomplete="new-password"
          v-model.trim="adminInfo.newPassword"
          placeholder="输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="newPasswordnext" v-if="showPwd">
        <el-input
          type="text"
          prefix-icon="el-icon-lock"
          show-password
          clearable
          autocomplete="new-password"
          v-model.trim="adminInfo.newPasswordnext"
          @keyup.native.enter="modifyPwd"
          placeholder="确认密码"
        ></el-input>
      </el-form-item>
    </el-form>
  </common-dialog>
</template>

<script>
import { checkNameNew, checkPassword } from "@/utils/checkForm";

export default {
  name: "AdminInfo",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.adminInfo.password !== '') {
            this.$http({
              url: this.$api.judge+ `?password=${this.adminInfo.password}`,
              method: "get"
            }).then(res => {
              if (res.data.code == 200) {//密码正确
                callback();
                return false
              }
              if(res.data.code == -1){//密码错误
                callback(new Error(res.data.msg));
              }
              
            });
          }
          
        }
      };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.adminInfo.newPasswordnext !== '') {
            this.$refs.adminInfo.validateField('newPasswordnext');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.adminInfo.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      adminInfo: {}, // 用户信息
      phone: "", // 用户手机号
      isEdit: false, // 编辑信息
      showPwd: true, // 显示密码框
      adminRules: {
        userName: [
          {
            required: true,
            // validator: checkName10,
            validator: checkNameNew,
            trigger: ["blur", "change"]
          }
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"]
          }
        ],
        // phone: [
        //   {
        //     required: true,
        //     validator: checkPhoneUnique,
        //     trigger: ["blur"]
        //   }
        // ],
        password: [
          {
            type: 'string',
            required: true,
            validator: validPass,
            trigger: ["blur", "change"]
          }
        ],
        newPassword: [
          {
            type: 'string',
            required: true,
            validator: validatePass,
            trigger: ["blur", "change"]
          },
          {
            pattern: /^(\w){5,25}$/,
            message: '只能输入5-25个字母、数字、下划线'
          },
        ],
        newPasswordnext: [
          {
            type: 'string',
            required: true,
            validator: validatePass2,
            trigger: ["blur", "change"]
          },
          {
            pattern: /^(\w){5,25}$/,
            message: '只能输入5-25个字母、数字、下划线'
          },
        ]
      }
    };
  },
  computed: {
    userId() {
      return this.$store.getters.userId ||  JSON.parse(sessionStorage.getItem("userinfo")).id;
    }
  },
  mounted() {
    // this.getAdminInfo();
  },
  methods: {
    // 获取所有的角色列表
    // getAdminInfo() {
    //   this.$http({
    //     url: this.$api.getUser + `/${this.userId}`,
    //     method: "get"
    //   }).then(res => {
    //     if (res.data.code === 0) {
    //       this.adminInfo = res.data.data;
    //     }
    //   });
    // },
    // 点击修改信息
    editAdmin() {
      this.isEdit = true;
      this.showPwd = false;
    },
    // 点击重置密码
    resetPwd() {
      this.isEdit = false;
      this.showPwd = true;
    },
    // 不通过点击确定按钮关闭弹窗
    handleClose() {
      this.$emit("update:showDialog", false);
      this.isEdit = false;
      this.showPwd = false;
      this.adminInfo = {};
      this.$refs["adminInfo"].resetFields();
    },
    // 编辑管理员信息 
    updateAdmin() {
      this.id = JSON.parse(sessionStorage.getItem("userinfo")).id;
      let { userName, email, phone, sex, id } = this.adminInfo;
      this.$refs["adminInfo"].validate(valid => {
        if (valid) {
          this.$http({
            // url: this.$api.adminUpdateInfo,
            url: this.$api.updateUser + `/${this.id}`,
            method: "PUT",
            data: { userName, email, phone, sex, id }
          }).then(res => {
            if (res.data.code === 0) {
              this.$toast("success", "修改成功");
            }
            this.$refs["adminInfo"].resetFields();
            this.isEdit = false;
            this.showPwd = false;
            this.$emit("update:showDialog", false);
          });
        } else {
          return false;
        }
      });
    },
    //校验原密码
    judge() {
      this.$refs["adminInfo"].validate(valid => {
        if (valid) {
          let { id, password } = this.adminInfo;
          this.$http({
            url: this.$api.judge,
            method: "get",
            data: {
              id: this.userId,
              password: password
            }
          }).then(res => {
            if (res.data.code == 0) {
              sessionStorage.clear();
              this.$store.dispatch("user/logout");
              this.$toast("success", "密码修改成功，请重新登录");
              this.$router.replace("/login");
            } else {
              this.$toast("error", res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重置密码
    modifyPwd() {
      this.$refs["adminInfo"].validate(valid => {
        if (valid) {
          let { id, newPassword } = this.adminInfo;
          this.$http({
            url: this.$api.updatePassword,
            method: "PUT",
            data: {
              id: this.userId,
              password: this.adminInfo.newPassword
            }
          }).then(res => {
            if (res.data.code == 200) {
              sessionStorage.clear();
              this.$store.dispatch("user/logout");
              this.$toast("success", "密码修改成功，请重新登录");
              this.$router.replace("/login");
            } else {
              this.$toast("error", res.data.msg);
            }
            // this.$refs["adminInfo"].resetFields();
            // this.isEdit = false;
            // this.showPwd = false;
            // this.$emit("update:showDialog", false);
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-btn {
  text-align: right;
}
/deep/.el-input {
  position: relative;
  font-size: 0.14rem;
  display: inline-block;
  width: 95%;
}
</style>